/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Report_Committedorganisations2Inputs */

const en_coinvestments_report_committedorganisations2 = /** @type {(inputs: Coinvestments_Report_Committedorganisations2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Committed Organisations`)
};

/**
* | output |
* | --- |
* | "Committed Organisations" |
*
* @param {Coinvestments_Report_Committedorganisations2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_report_committedorganisations2 = /** @type {((inputs?: Coinvestments_Report_Committedorganisations2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Report_Committedorganisations2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_report_committedorganisations2(inputs)
});
export { coinvestments_report_committedorganisations2 as "coInvestments_report_committedOrganisations" }